export default "__VITE_ASSET__BpTRNoeE__"